// extracted by mini-css-extract-plugin
module.exports = {"root":"FileEmpty_root__3B6SR","iconBlock":"FileEmpty_iconBlock__2KIEo","text":"FileEmpty_text__2z99c"};